import { all, put, race, take, takeEvery } from 'redux-saga/effects'

import { EXPORT_SHOW_UPSELL_DIALOG, SHOW_UPSELL_DIALOG_ID } from './constants'
import { CONFIRM_DIALOG_ON_BUTTON_CLICK } from '../../../../../../../../../components/Dialog/components/Confirm/constants'
import { ACTION_CD, MODULE_CD } from '../../../../../../../../../services/logAction/constants'

import { openDialog } from '../../../../../../../../../services/dialog/actions'
import { logAction } from '../../../../../../../../../services/logAction/actions'

function* onShowUpsellDialog() {
    yield put(
        logAction({
            actionCd: ACTION_CD.UPSELL_CLICK,
            moduleCd: MODULE_CD.PORTFOLIO,
            note: 'xlsExport',
            parameters: {
                onClick: 'xlsExport',
            },
        })
    )

    const dialogSettings = {
        header: { textId: 'portfolioExport', icon: '' },
        question: {
            textId: 'portfolioExport',
        },
        buttons: [{ key: 'more', color: 'blue' }, 'close'],
    }

    const userResponse = yield all({
        answer: race({
            more: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('more', SHOW_UPSELL_DIALOG_ID)),
            close: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('close', SHOW_UPSELL_DIALOG_ID)),
        }),
        dialog: put(openDialog('confirm', SHOW_UPSELL_DIALOG_ID, dialogSettings)),
    })

    if (userResponse.answer.more) {
        window.open('https://www.dnb.com/cs-cz/produkty/gnosus/')
    }

    return null
}

export default function* linkagesSaga() {
    yield all([takeEvery(EXPORT_SHOW_UPSELL_DIALOG, onShowUpsellDialog)])
}
